// @need-translate
import { useRouter } from 'next/router';
import { ReactElement, useMemo } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { requestContext } from '../../../common/requestContext';
import useTypedSelector from '../../../common/useTypedSelector';
import { Layout } from '../../../design-system/layout/Layout';
import { SearchAutoCompleteWrapper } from '../../../design-system/organisms/SearchAutoCompleteWrapper/SearchAutoCompleteWrapper';
import { CATEGORY_UID_TO_TITLE_MAP, SEARCH_DEFAULT_CATEGORY_UID } from '../../../domain/search/constant';
import { SearchAutoCompleteContainer } from '../../../domain/search/container/SearchAutoCompleteContainer';
import { SearchKeywordContainer } from '../../../domain/search/result/container/SearchKeywordContainer';
import { createSearchKeywordInput } from '../../../domain/search/util/createSearchKeywordInput';
import { validateSearchKeywordSearchParam } from '../../../domain/search/util/typeguard';
import { ExceptionMobileHeaderType } from '../../../header/constants';
import { ReactQueryInfiniteType } from '../../../reactQuery/CodegenReactQueryType.type';
import { CACHE_ONLY_CONFIG } from '../../../reactQuery/constant';
import { ReactQueryFetcher } from '../../../reactQuery/ReactQueryFetcher';
import { ReactQueryInfiniteFetcher } from '../../../reactQuery/ReactQueryInfiniteFetcher';
import { useInfiniteSearchKeywordQuery, useSearchAutoCompleteQuery } from '../../../wrapper/searchWrapper';
function SearchResultPage() {
  const {
    query,
    isReady
  } = useRouter();
  const searchKeywordInput = useMemo(() => {
    if (!validateSearchKeywordSearchParam(query)) {
      return;
    }
    return createSearchKeywordInput(query);
  }, [query]);
  const {
    openAutoComplete,
    searchKeyword
  } = useTypedSelector(state => state.search);
  const isMobile = requestContext.requestInfo.display.isMobile;
  return <>
      {isMobile && openAutoComplete && <SearchAutoCompleteWrapper isMobile={true}>
          <ReactQueryFetcher reactQuery={useSearchAutoCompleteQuery} variables={{
        input: {
          keyword: searchKeyword
        }
      }} options={{
        ...CACHE_ONLY_CONFIG,
        enabled: !!searchKeyword
      }} shouldRemoveCacheAfterUnmount={!searchKeyword}>
            {data => <SearchAutoCompleteContainer data={data} />}
          </ReactQueryFetcher>
        </SearchAutoCompleteWrapper>}

      {isReady && !searchKeywordInput && <div className="font-medium1 text-theme-solid-100 flex-center-full">
          {t('search_result_empty')}
        </div>}

      {isReady && !!searchKeywordInput && <ReactQueryInfiniteFetcher variables={{
      input: searchKeywordInput
    }} reactQuery={useInfiniteSearchKeywordQuery} type={ReactQueryInfiniteType.InfinityScroll} options={{
      initialPageParam: {
        input: {
          ...searchKeywordInput,
          page: 0
        }
      },
      getNextPageParam: lastPage => {
        return lastPage.searchKeyword?.isEnd ? undefined : {
          input: {
            ...searchKeywordInput,
            page: (lastPage.searchKeyword?.page || 0) + 1
          }
        };
      }
    }}>
          {data => <SearchKeywordContainer data={data} searchKeywordInput={searchKeywordInput} />}
        </ReactQueryInfiniteFetcher>}

      {isReady && searchKeywordInput && <TrackPageViewContainer trackObj={{
      section: '검색',
      page: `검색_검색결과_${CATEGORY_UID_TO_TITLE_MAP[searchKeywordInput.categoryUid || SEARCH_DEFAULT_CATEGORY_UID]}`,
      actionType: 'Pageview',
      actionName: '검색_검색결과_화면',
      actionKind: 'Search',
      customProps: {
        user_action: 'pv'
      },
      search: {
        search_term: searchKeywordInput.keyword
      }
    }} />}
    </>;
}
SearchResultPage.getLayout = function (page: ReactElement) {
  return <Layout title="검색 결과" mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: ExceptionMobileHeaderType.Search
  }} pcLayoutConfig={{
    shouldShowHeader: true
  }}>
      {page}
    </Layout>;
};
export default SearchResultPage;